// Owner: engagements (owner feedback F19). The `engagement-log` and `task-create` layers: "Log a call / Add a note /
// Log a meeting" and "Add a task" from anywhere; `engagement-links` (the records of an activity) and `mailbox-link`
// (a message of one's own mailbox on a record). Load on first open (`features/engagements/events.ts` opens them).
import { lazy } from 'react';
import { defineGlobalLayer } from '../shell/overlays';
import '../features/engagements/events';

export default [
  defineGlobalLayer({
    id: 'engagement-log',
    component: lazy(() => import('../features/engagements/LogEngagementDialog')),
  }),
  defineGlobalLayer({
    id: 'task-create',
    component: lazy(() => import('../features/engagements/CreateTaskLayer')),
  }),
  defineGlobalLayer({
    id: 'engagement-links',
    component: lazy(() => import('../features/engagements/EngagementLinksDialog')),
  }),
  defineGlobalLayer({
    id: 'mailbox-link',
    component: lazy(() => import('../features/engagements/MailboxLinkDialog')),
  }),
];
